var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2028_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.0517 0 10.2857 0.782031 10.2857 1.75V2.8C6.37495 3.60938 3.42852 7.14219 3.42852 11.375V12.4031C3.42852 14.9734 2.50174 17.4562 0.830308 19.3813L0.43388 19.8352C-0.0161203 20.3492 -0.123263 21.0875 0.149951 21.7164C0.423165 22.3453 1.03924 22.75 1.71424 22.75H22.2857C22.9607 22.75 23.5714 22.3453 23.85 21.7164C24.1285 21.0875 24.016 20.3492 23.566 19.8352L23.1696 19.3813C21.4982 17.4562 20.5714 14.9789 20.5714 12.4031V11.375C20.5714 7.14219 17.625 3.60938 13.7142 2.8V1.75C13.7142 0.782031 12.9482 0 12 0ZM14.4267 26.9773C15.0696 26.3211 15.4285 25.4297 15.4285 24.5H12H8.57138C8.57138 25.4297 8.93031 26.3211 9.57316 26.9773C10.216 27.6336 11.0892 28 12 28C12.9107 28 13.7839 27.6336 14.4267 26.9773Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2028_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.689e9c1afaa0103cc3233afa9a2bf43e.svg";
export { ForwardRef as ReactComponent };